<template>
  <div class="nav-container" :class="$route.name">
    <nav class="nav">
      <router-link to="/forecast" class="btn">{{ $parent.content[1].name }}</router-link>
      <router-link to="/accumulation" class="btn">{{ $parent.content[2].name }}</router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
}
</script>

<style scoped lang="scss">
@import '@/assets/main.scss';

.nav-container {
  max-width: 425px;
  width: 100%;
  margin: 0 auto;
  padding: 20px 20px 0px;  
  margin-top: -100%;
  transition: 0.7s ease 0.5s, filter 0.3s linear 0s;
}

.nav {
  transition: 0.5s ease;
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 15px;
  border: 1.5px solid;
  border-image-source: linear-gradient(197.96deg, rgba(255, 255, 255, 0.2) 10.17%, rgba(255, 255, 255, 0.1) 85.83%);
  .btn {
    transition: 0.3s;
    height: 30px;
    padding: 0;
    border: none;
    background: none;
    text-decoration: none;
    display: block;
    width: 100%;
    font-family: 'Rubik', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: center;
    z-index: 1;
  }
  &::before {
    transition: 0.5s ease;
    content: '';
    width: 50%;
    height: 100%;
    background: $btn_grad_1;
    border-radius: 15px;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.nav-container.Home {
  margin-top: -100%;
  .nav .btn:not(:last-child) {
    color: $white;
  }
}
.nav-container.Forecast {
  margin-top: 0;
  .nav {
    &::before {
      left: 0;
    }
    .btn:first-child {
      color: $white;
    }
  }
}
.nav-container.Accumulation {
  margin-top: 0;
  .nav {
    &::before {
      left: 50%;
      background: linear-gradient(80.66deg, #8D2DB3 0%, #E40377 100%);
    }
    .btn:last-child {
      color: $white;
    }
  }
}
</style>